import { z } from "zod";
import { DAYS, DESCRIPTION, TERM } from "../consts";

export const schema = z.object({
  [TERM]: z.string().min(1, "This field is required"),
  [DAYS]: z.string().min(1, "This field is required"),
  [DESCRIPTION]: z.string().optional(),
});

export type formValues = z.infer<typeof schema>;
